import { render, staticRenderFns } from "./ModuleOutlet.vue?vue&type=template&id=1d5de87b&scoped=true&lang=pug"
import script from "./ModuleOutlet.vue?vue&type=script&lang=ts"
export * from "./ModuleOutlet.vue?vue&type=script&lang=ts"
import style0 from "./ModuleOutlet.vue?vue&type=style&index=0&id=1d5de87b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5de87b",
  null
  
)

export default component.exports